import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'region',
    serviceName: 'auth',
    query: gql`
      query region($ids: [String], $title: String, $shop_ids: [String], $for_admin: Int) {
        region(ids: $ids, title: $title, shop_ids: $shop_ids, for_admin: $for_admin) {
          data {
            id
            title
            area
            shop {
              title
            }
          }
          total
        }
      }
    `,
  },
  delete: {
    name: 'deleteRegion',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteRegion($ids: [String]!) {
        deleteRegion(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'region',
    serviceName: 'auth',
    query: gql`
      query region($ids: [String]) {
        region(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'region',
    serviceName: 'auth',
    query: gql`
      query region($ids: [String]) {
        region(ids: $ids) {
          data {
            id
            title
            media {
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
